import React from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { AnimationOnScroll } from 'react-animation-on-scroll';

const Discover = () => {
    const navigate = useNavigate();

    const handleContactClick = () => {
        navigate('/contact-us');
    };

    return (
        <Container className="py-5 discover">
            <AnimationOnScroll animateOnce={true} animateIn="animate__fadeInUp" duration={0.5} offset={100}>
                <div className="row justify-content-center text-center">
                    <div className="col-lg-8">
                        <h1 className="discover__title mb-2">Discover Tailored Digital Solutions</h1>
                        <h2 className="discover__subtitle mb-4">That Drive Results</h2>
                        <p className="mb-5 fs-5 content text-center">
                            Tell us what you need, we're ready to help.
                        </p>
                        <button
                            type="button"
                            className="btn btn-lg discover__button"
                            onClick={handleContactClick}
                        >
                            Contact Us
                        </button>
                    </div>
                </div>
            </AnimationOnScroll>
        </Container>
    );
};

export default Discover;
